import { CartItemDetails } from '../data/store-data';
import React from 'react';

let cart: CartItemDetails[] = [];

const CartContext = React.createContext({
  cart,
  setCart(cart: CartItemDetails[]) {
    this.cart = cart;
  },
});

export { CartContext };
